module.exports = __webpack_public_path__ + "img/seyahat-saglik-sigortasi.92339d73.png";